module.exports = function getResource(label, vars = []) {
    let resources = {
        reviewRecentPurchases: 'Visionner les achats récents'
    };
    return resources[label];
};
